import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export const SubjectTypeItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Change Subject Type"
                description="Change the subject type for a single subject"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
